module.exports = __webpack_public_path__ + "img/banner2.64de6c0.png";